import { render, staticRenderFns } from "./MappingsPanel.vue?vue&type=template&id=04fa2576"
import script from "./MappingsPanel.vue?vue&type=script&lang=js"
export * from "./MappingsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports